(function() {
  const _headerScriptSrc = (document.currentScript && document.currentScript.getAttribute('src')) || '';

  function _localUserId() {
    try {
      const raw = localStorage.getItem('user');
      const u = raw ? JSON.parse(raw) : null;
      return (u && u.id != null) ? String(u.id) : null;
    } catch (_e) { return null; }
  }
  function _userPrefKey(name) {
    const uid = _localUserId();
    return 'pcbweave.u' + (uid || '_anon') + '.' + name;
  }

  // Theme ids.
  // USER_THEME_IDS — toggle + localStorage restore (user-facing only).
  // ALL_THEME_IDS — applyTheme / getTheme (includes internal parity theme
  // `kicad`: light UI chrome + KiCad Default schematic canvas palette).
  const USER_THEME_IDS = ['light', 'dark'];
  const ALL_THEME_IDS = ['light', 'dark', 'kicad'];
  function _normalizeTheme(theme) {
    // Programmatic applyTheme accepts every valid id, including kicad.
    return ALL_THEME_IDS.indexOf(theme) >= 0 ? theme : 'light';
  }
  function _normalizeUserTheme(theme) {
    // User prefs / toggle never accept internal parity themes.
    return USER_THEME_IDS.indexOf(theme) >= 0 ? theme : 'light';
  }
  // Note: applyTheme() is also called at the top of every page via
  // window.applyTheme before header.js loads, so the page paints with
  // the correct theme.
  function applyTheme(theme) {
    theme = _normalizeTheme(theme);
    document.documentElement.dataset.theme = theme;
    // kicad keeps light UI chrome; only canvas tokens differ.
    document.documentElement.style.colorScheme = (theme === 'dark') ? 'dark' : 'light';
    // Only persist user-selectable themes so kicad never sticks as a pref.
    if (USER_THEME_IDS.indexOf(theme) >= 0) {
      try { localStorage.setItem(_userPrefKey('theme'), theme); } catch (e) {} // storage blocked in private/incognito mode
      try { localStorage.setItem('theme', theme); } catch (e) {} // storage blocked in private/incognito mode
    }
    try {
      window.dispatchEvent(new CustomEvent('themechange', { detail: { theme: theme } }));
    } catch (e) {} // listener may throw; don't let it break theme application
  }
  function toggleTheme() {
    const cur = _normalizeUserTheme(document.documentElement.dataset.theme || 'light');
    const i = USER_THEME_IDS.indexOf(cur);
    applyTheme(USER_THEME_IDS[(i + 1) % USER_THEME_IDS.length]);
  }
  window.applyTheme = applyTheme;
  window.getTheme = function() {
    return _normalizeTheme(document.documentElement.dataset.theme);
  };

  // If the theme attr wasn't set by the early pre-header script, set it now
  // from localStorage (fallback). Only user-selectable prefs are restored;
  // a stale 'kicad' pref normalizes to light.
  if (!document.documentElement.dataset.theme) {
    try {
      const saved = localStorage.getItem(_userPrefKey('theme'));
      applyTheme(_normalizeUserTheme(saved));
    } catch (e) {} // storage blocked in private/incognito mode
  }

  // Pages that must remain browsable by anonymous visitors opt out of the
  // redirect by setting `data-allow-anon` on <html>. When that flag is present
  // and the user is not logged in, we render a logged-out header (Sign In /
  // Sign Up) instead of bouncing to /login.
  const _allowAnon = document.documentElement.hasAttribute('data-allow-anon');
  const _isAuthed = !!localStorage.getItem('token');
  if (!_isAuthed && !_allowAnon) {
    location.href = '/login';
    return;
  }

  // When the browser restores this page from BFCache (back/forward navigation
  // after logout), re-check auth so the stale logged-in view doesn't persist.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted && !localStorage.getItem('token') && !_allowAnon) {
      location.replace('/login');
    }
  });

  const _pageId = document.documentElement.getAttribute('data-page') || '';

  // Logo always goes to the landing page.
  const _logoHref = '/';
  try {
    document.querySelectorAll('a.logo').forEach(el => el.setAttribute('href', _logoHref));
  } catch (e) {} // defensive: DOM may not be ready on some pages

  function _getInitials(displayName, username) {
    const name = (displayName || username || 'U').trim();
    const words = name.split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  }

  function _setAttrs(el, attrs) {
    for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
  }

  function _authHeaders() {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': 'Bearer ' + token } : {};
  }

  const _anonNavLinks = [
    { href: '/help', label: 'Help', testid: 'nav-help', activePage: 'help' },
  ];

  function _makeLink(spec) {
    const a = document.createElement('a');
    const attrs = { href: spec.href || '#' };
    if (spec.id) attrs.id = spec.id;
    if (spec.testid) attrs['data-testid'] = spec.testid;
    if (spec.className) attrs.class = spec.className;
    _setAttrs(a, attrs);
    a.textContent = spec.label || '';
    if (spec.activePage && spec.activePage === _pageId) a.classList.add('active');
    if (spec.children) a.append(...spec.children);
    if (spec.onClick) a.addEventListener('click', spec.onClick);
    return a;
  }

  function _makeNavLink(spec) {
    return _makeLink({
      ...spec,
      className: 'pcbw-nav-link',
    });
  }

  function _makeSeparator() {
    const sep = document.createElement('div');
    sep.className = 'user-menu-sep';
    return sep;
  }

  function _appendMenuItems(menu, specs) {
    menu.append(...specs.map(spec => spec.separator ? _makeSeparator() : _makeLink(spec)));
  }

  function _createThemeToggleButton() {
    const btn = document.createElement('button');
    btn.className = 'theme-toggle';
    btn.id = 'theme-toggle';
    btn.setAttribute('data-testid', 'theme-toggle');
    btn.setAttribute('title', 'Toggle theme (light / dark)');
    btn.setAttribute('aria-label', 'Toggle theme (light / dark)');
    btn.textContent = '🌓';
    return btn;
  }

  function _attachFloatingDropdown({ button, panel, isOpen, open, close, position, onOpen, reparent = true }) {
    function _isOpen() {
      return isOpen ? isOpen() : panel.style.display === 'block';
    }
    function _close() {
      close();
      button.setAttribute('aria-expanded', 'false');
    }
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      if (_isOpen()) {
        _close();
        return;
      }
      if (reparent && panel.parentElement !== document.body) {
        document.body.appendChild(panel);
      }
      position();
      open();
      button.setAttribute('aria-expanded', 'true');
      if (onOpen) onOpen();
    });
    document.addEventListener('click', (e) => {
      if (!button.contains(e.target) && !panel.contains(e.target)) {
        _close();
      }
    });
    window.addEventListener('resize', () => {
      if (_isOpen()) position();
    });
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') _close();
    });
  }

  // -----------------------------------------------------------------------
  // Site top-nav with search + avatar dropdown
  // -----------------------------------------------------------------------
    const _headerLeft = document.querySelector('.header-left');
    if (_headerLeft && !_headerLeft.querySelector('.pcbw-search-form')) {
      const searchForm = document.createElement('form');
      searchForm.className = 'pcbw-search-form';
      searchForm.setAttribute('action', '/search');
      searchForm.setAttribute('method', 'get');
      searchForm.setAttribute('role', 'search');
      searchForm.setAttribute('aria-label', 'Search users and projects');
      const searchInput = document.createElement('input');
      searchInput.type = 'search';
      searchInput.id = 'pcbw-search-input';
      searchInput.name = 'q';
      searchInput.className = 'pcbw-search-input';
      searchInput.placeholder = 'Search users and projects…';
      searchInput.setAttribute('aria-label', 'Search users and projects');
      searchInput.setAttribute('autocomplete', 'off');
      const searchDropdown = document.createElement('div');
      searchDropdown.className = 'search-dropdown';
      searchDropdown.setAttribute('hidden', '');
      searchDropdown.setAttribute('role', 'listbox');
      searchDropdown.setAttribute('data-testid', 'search-dropdown');
      searchForm.appendChild(searchInput);
      searchForm.appendChild(searchDropdown);
      const logoEl = _headerLeft.querySelector('a.logo');
      if (logoEl && logoEl.nextSibling) {
        _headerLeft.insertBefore(searchForm, logoEl.nextSibling);
      } else {
        _headerLeft.appendChild(searchForm);
      }

      // ---- Inline search dropdown logic ----
      let _searchTimer = null;
      let _searchActiveIdx = -1;
      let _searchResults = [];

      function _searchGetItems() {
        return searchDropdown.querySelectorAll('.search-result');
      }

      function _searchSetActive(idx) {
        const items = _searchGetItems();
        items.forEach(function(el, i) {
          el.classList.toggle('active', i === idx);
        });
        _searchActiveIdx = idx;
      }

      function _kindIcon(kind) {
        if (kind === 'user') return '👤';
        if (kind === 'project') return '📐';
        return '•';
      }

      function _renderDropdown(results) {
        searchDropdown.innerHTML = '';
        const kindOrder = ['user', 'project'];
        const allowedKinds = new Set(kindOrder);
        const renderedResults = (results || []).filter(function(r) {
          return r && allowedKinds.has(r.kind);
        });
        if (!renderedResults.length) {
          const empty = document.createElement('div');
          empty.className = 'search-dropdown-empty';
          empty.textContent = 'No results';
          searchDropdown.appendChild(empty);
          _searchResults = [];
          _searchActiveIdx = -1;
          return;
        }

        const byKind = {};
        renderedResults.forEach(function(r) {
          if (!byKind[r.kind]) byKind[r.kind] = [];
          byKind[r.kind].push(r);
        });

        kindOrder.forEach(function(kind) {
          const group = byKind[kind];
          if (!group || !group.length) return;
          const header = document.createElement('div');
          header.className = 'search-result-group';
          const labels = {
            user: 'Users', project: 'Projects',
          };
          header.textContent = labels[kind] || kind;
          searchDropdown.appendChild(header);
          group.forEach(function(r) {
            const a = document.createElement('a');
            a.className = 'search-result';
            a.href = r.url || '#';
            a.setAttribute('role', 'option');
            const topLine = document.createElement('div');
            const kindSpan = document.createElement('span');
            kindSpan.className = 'search-result-kind';
            kindSpan.textContent = _kindIcon(r.kind);
            const nameSpan = document.createElement('span');
            nameSpan.className = 'search-result-name';
            nameSpan.textContent = r.name || r.slug || '';
            topLine.appendChild(kindSpan);
            topLine.appendChild(nameSpan);
            if (r.owner_username) {
              const ownerSpan = document.createElement('span');
              ownerSpan.className = 'search-result-owner';
              ownerSpan.textContent = '@' + r.owner_username;
              topLine.appendChild(ownerSpan);
            }
            a.appendChild(topLine);
            if (r.description) {
              const descDiv = document.createElement('div');
              descDiv.className = 'search-result-desc';
              descDiv.textContent = r.description;
              a.appendChild(descDiv);
            }
            a.addEventListener('mousedown', function(e) {
              e.preventDefault();
              location.href = r.url || '#';
            });
            searchDropdown.appendChild(a);
          });
        });

        _searchResults = renderedResults;
        _searchActiveIdx = -1;
      }

      function _closeDropdown() {
        searchDropdown.setAttribute('hidden', '');
        searchDropdown.innerHTML = '';
        _searchActiveIdx = -1;
        _searchResults = [];
      }

      function _openDropdown() {
        searchDropdown.removeAttribute('hidden');
      }

      let _lastFetchedQ = '';
      function _doSearch(q) {
        if (!q) { _closeDropdown(); return; }
        if (q === _lastFetchedQ && !searchDropdown.hasAttribute('hidden')) return;
        _lastFetchedQ = q;
        const url = '/api/search?q=' + encodeURIComponent(q) + '&limit=12';
        const headers = {};
        const token = localStorage.getItem('token');
        if (token) headers['Authorization'] = 'Bearer ' + token;
        fetch(url, { headers: headers })
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(data) {
            if (searchInput.value.trim() !== q) return;
            if (!data) { _closeDropdown(); return; }
            _renderDropdown(data.results || []);
            _openDropdown();
          })
          .catch(function(err) {
            console.warn('[header] search fetch failed:', err && err.message);
            // Drop the advanced _lastFetchedQ so the same query can retry, and
            // close any stale results that belonged to a previous successful query.
            if (_lastFetchedQ === q) _lastFetchedQ = '';
            if (searchInput.value.trim() === q) _closeDropdown();
          });
      }

      searchInput.addEventListener('keyup', function(e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === 'Escape') return;
        clearTimeout(_searchTimer);
        const q = searchInput.value.trim();
        if (!q) { _closeDropdown(); return; }
        _searchTimer = setTimeout(function() { _doSearch(q); }, 250);
      });

      searchInput.addEventListener('keydown', function(e) {
        const items = _searchGetItems();
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = (_searchActiveIdx + 1) % (items.length || 1);
          _searchSetActive(next < items.length ? next : 0);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = _searchActiveIdx <= 0 ? items.length - 1 : _searchActiveIdx - 1;
          _searchSetActive(prev);
        } else if (e.key === 'Enter') {
          if (_searchActiveIdx >= 0 && items[_searchActiveIdx]) {
            e.preventDefault();
            location.href = items[_searchActiveIdx].href;
          }
        } else if (e.key === 'Escape') {
          _closeDropdown();
          searchInput.blur();
        }
      });

      searchForm.addEventListener('submit', function(e) {
        if (_searchActiveIdx >= 0) {
          const items = _searchGetItems();
          if (items[_searchActiveIdx]) {
            e.preventDefault();
            location.href = items[_searchActiveIdx].href;
            return;
          }
        }
        _closeDropdown();
      });

      document.addEventListener('click', function(e) {
        if (!searchForm.contains(e.target)) {
          _closeDropdown();
        }
      });

      window.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          _closeDropdown();
        }
      });
    }

    const _headerRight = document.querySelector('.header-right');
    if (_headerRight) {
      _headerRight.innerHTML = '';

      const _themeToggleBtn = _createThemeToggleButton();

      if (_isAuthed) {
        // Notifications bell
        const notifBtn = document.createElement('button');
        notifBtn.className = 'pcbw-notif-btn';
        notifBtn.setAttribute('aria-label', 'Notifications');
        notifBtn.setAttribute('aria-haspopup', 'true');
        notifBtn.setAttribute('aria-expanded', 'false');
        notifBtn.setAttribute('data-testid', 'nav-notifications');
        notifBtn.textContent = '🔔';

        // Avatar button + dropdown
        const menuContainer = document.createElement('div');
        menuContainer.id = 'user-menu-container';
        menuContainer.style.position = 'relative';

        let _storedUser = {};
        try { _storedUser = JSON.parse(localStorage.getItem('user') || '{}'); } catch (e) {} // storage blocked or corrupted JSON
        const _initials = _getInitials(_storedUser.display_name, _storedUser.username);
        const _username = _storedUser.username || '';

        const avatarBtn = document.createElement('button');
        _setAttrs(avatarBtn, {
          id: 'user-menu-btn',
          'data-testid': 'user-menu-btn',
          class: 'user-avatar-btn',
          'aria-label': 'User menu',
          'aria-haspopup': 'true',
          'aria-expanded': 'false',
        });
        if (_storedUser.avatar_url) {
          const img = document.createElement('img');
          img.src = _storedUser.avatar_url;
          img.alt = 'Avatar';
          img.style.cssText = 'width:100%;height:100%;border-radius:50%;object-fit:cover;';
          avatarBtn.appendChild(img);
        } else {
          avatarBtn.textContent = _initials;
        }

        const menuDropdown = document.createElement('div');
        _setAttrs(menuDropdown, {
          id: 'user-menu-dropdown',
          'data-testid': 'user-menu-dropdown',
          class: 'user-menu-dropdown',
        });

        const themeLabel = document.createElement('span');
        themeLabel.id = 'user-menu-theme-label';
        themeLabel.textContent = 'Dark mode';
        _appendMenuItems(menuDropdown, [
          { href: '/' + _username, label: 'Your profile', id: 'user-menu-profile', testid: 'user-menu-profile' },
          { href: '/settings', label: 'Settings', testid: 'user-menu-settings' },
          { separator: true },
          { href: '#', id: 'user-menu-theme', testid: 'user-menu-theme', children: [themeLabel] },
          { href: '#', label: 'Report a bug', id: 'user-menu-report-bug', testid: 'user-menu-report-bug' },
          { separator: true },
          { href: '#', label: 'Sign out', id: 'user-menu-logout', testid: 'user-menu-logout', className: 'user-menu-logout' },
        ]);
        menuContainer.append(avatarBtn, menuDropdown);
        _headerRight.append(notifBtn, _themeToggleBtn, menuContainer);

      } else {
        const navLinks = _anonNavLinks.map(_makeNavLink);

        const menuContainer = document.createElement('div');
        menuContainer.id = 'user-menu-container';
        menuContainer.style.cssText = 'display:flex;align-items:center;gap:8px;';

        const loginLink = _makeLink({
          href: '/login',
          label: 'Sign in',
          id: 'anon-login-btn',
          testid: 'anon-login-btn',
          className: 'btn btn-outline btn-sm',
        });

        const signupLink = _makeLink({
          href: '/login?key=',
          label: 'Sign up',
          id: 'anon-signup-btn',
          testid: 'anon-signup-btn',
          className: 'btn btn-primary btn-sm',
        });

        menuContainer.append(loginLink, signupLink);
        _headerRight.append(...navLinks, _themeToggleBtn, menuContainer);
      }
  }

  // -----------------------------------------------------------------------
  // Notifications dropdown
  // -----------------------------------------------------------------------
  function _formatNotifTime(iso) {
    if (!iso) return '';
    const ts = new Date(iso).getTime();
    if (!Number.isFinite(ts)) return '';
    const seconds = Math.max(0, Math.floor((Date.now() - ts) / 1000));
    if (seconds < 60) return 'just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return minutes + 'm ago';
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return hours + 'h ago';
    const days = Math.floor(hours / 24);
    if (days < 7) return days + 'd ago';
    return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }

  function _positionNotifDropdown(btn, dropdown) {
    const rect = btn.getBoundingClientRect();
    dropdown.style.top = (rect.bottom + 6) + 'px';
    dropdown.style.right = Math.max(12, window.innerWidth - rect.right) + 'px';
  }

  async function _refreshNotifBadge() {
    try {
      const r = await fetch('/api/auth/me/notifications/unread-count', { headers: _authHeaders() });
      if (!r.ok) return;
      const data = await r.json();
      const btn = document.querySelector('.pcbw-notif-btn');
      if (!btn) return;
      const count = Number(data.count || 0);
      if (count > 0) {
        btn.dataset.unread = count > 99 ? '99+' : String(count);
        btn.classList.add('has-unread');
      } else {
        btn.removeAttribute('data-unread');
        btn.classList.remove('has-unread');
      }
    } catch (_e) { console.warn('[header] notif badge refresh failed:', _e && _e.message); }
  }

  function _renderNotifRows(listEl, rows, dropdown) {
    listEl.replaceChildren();
    if (!rows || rows.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'pcbw-notif-empty';
      empty.textContent = 'No notifications yet.';
      listEl.appendChild(empty);
      return;
    }
    rows.forEach(row => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pcbw-notif-row' + (row.read ? '' : ' unread');
      const title = document.createElement('span');
      title.className = 'pcbw-notif-row-title';
      title.textContent = row.text || 'Notification';
      const time = document.createElement('span');
      time.className = 'pcbw-notif-row-time';
      time.textContent = _formatNotifTime(row.created_at);
      btn.append(title, time);
      btn.addEventListener('click', async () => {
        try {
          await fetch('/api/auth/me/notifications/' + encodeURIComponent(row.id) + '/mark-read', {
            method: 'POST',
            headers: _authHeaders(),
          });
        } catch (_e) { console.debug('[silent:mark-notification-read]', _e instanceof Error ? _e.message : String(_e)); }
        dropdown.classList.remove('open');
        const targetUrl = row.url || '/';
        location.href = targetUrl;
      });
      listEl.appendChild(btn);
    });
  }

  async function _loadNotifDropdown(listEl, dropdown) {
    listEl.replaceChildren();
    const loading = document.createElement('div');
    loading.className = 'pcbw-notif-loading';
    loading.textContent = 'Loading notifications…';
    listEl.appendChild(loading);
    try {
      const r = await fetch('/api/auth/me/notifications?limit=20', { headers: _authHeaders() });
      if (!r.ok) throw new Error('load failed');
      _renderNotifRows(listEl, await r.json(), dropdown);
    } catch (_e) {
      listEl.replaceChildren();
      const empty = document.createElement('div');
      empty.className = 'pcbw-notif-empty';
      empty.textContent = 'Notifications are unavailable.';
      listEl.appendChild(empty);
    }
  }

  const _notifBtn = document.querySelector('.pcbw-notif-btn');
  if (_isAuthed && _notifBtn) {
    const notifDropdown = document.createElement('div');
    notifDropdown.className = 'pcbw-notif-dropdown';
    notifDropdown.setAttribute('data-testid', 'nav-notifications-dropdown');

    const notifHead = document.createElement('div');
    notifHead.className = 'pcbw-notif-head';
    notifHead.textContent = 'Notifications';

    const notifList = document.createElement('div');
    notifList.className = 'pcbw-notif-list';

    const notifFooter = document.createElement('div');
    notifFooter.className = 'pcbw-notif-footer';
    const markAllBtn = document.createElement('button');
    markAllBtn.type = 'button';
    markAllBtn.className = 'pcbw-notif-mark-all';
    markAllBtn.textContent = 'Mark all read';
    markAllBtn.addEventListener('click', async () => {
      try {
        await fetch('/api/auth/me/notifications/mark-all-read', {
          method: 'POST',
          headers: _authHeaders(),
        });
      } catch (_e) {
        console.debug('[silent:mark-all-notifications-read]', _e instanceof Error ? _e.message : String(_e));
        window.showToast('Could not mark notifications read', 'error');
      }
      await _refreshNotifBadge();
      await _loadNotifDropdown(notifList, notifDropdown);
    });
    notifFooter.appendChild(markAllBtn);
    notifDropdown.append(notifHead, notifList, notifFooter);
    document.body.appendChild(notifDropdown);

    _attachFloatingDropdown({
      button: _notifBtn,
      panel: notifDropdown,
      isOpen: () => notifDropdown.classList.contains('open'),
      open: () => notifDropdown.classList.add('open'),
      close: () => notifDropdown.classList.remove('open'),
      position: () => _positionNotifDropdown(_notifBtn, notifDropdown),
      onOpen: () => _loadNotifDropdown(notifList, notifDropdown),
      reparent: false,
    });
    const isJsdom = typeof navigator !== 'undefined' && /jsdom/i.test(navigator.userAgent || '');
    if (!isJsdom) {
      const notifBadgeTimer = setInterval(_refreshNotifBadge, 60000);
      if (notifBadgeTimer && typeof notifBadgeTimer.unref === 'function') {
        notifBadgeTimer.unref();
      }
    }
    _refreshNotifBadge();
  }

  // -----------------------------------------------------------------------
  // User-menu dropdown
  // -----------------------------------------------------------------------
  const _menuBtn = document.getElementById('user-menu-btn');
  const _menuDrop = document.getElementById('user-menu-dropdown');
  if (_menuBtn && _menuDrop) {
    function _positionDropdown() {
      const rect = _menuBtn.getBoundingClientRect();
      _menuDrop.style.top = (rect.bottom + 4) + 'px';
      _menuDrop.style.right = (window.innerWidth - rect.right) + 'px';
    }
    _attachFloatingDropdown({
      button: _menuBtn,
      panel: _menuDrop,
      isOpen: () => _menuDrop.style.display === 'block',
      open: () => { _menuDrop.style.display = 'block'; },
      close: () => { _menuDrop.style.display = 'none'; },
      position: _positionDropdown,
    });
  }

  // -----------------------------------------------------------------------
  // Theme toggle
  // -----------------------------------------------------------------------
  function _updateThemeLabel() {
    const lbl = document.getElementById('user-menu-theme-label');
    if (!lbl) return;
    // Label shows the *next* user-selectable theme the toggle will apply.
    const cur = _normalizeUserTheme(document.documentElement.dataset.theme || 'light');
    lbl.textContent = (cur === 'light') ? 'Dark mode' : 'Light mode';
  }
  _updateThemeLabel();
  const _themeLink = document.getElementById('user-menu-theme');
  if (_themeLink) {
    _themeLink.addEventListener('click', (e) => {
      e.preventDefault();
      toggleTheme();
      _updateThemeLabel();
      const dd = document.getElementById('user-menu-dropdown');
      if (dd) dd.style.display = 'none';
    });
  }

  const _headerThemeToggle = document.getElementById('theme-toggle');
  if (_headerThemeToggle) {
    _headerThemeToggle.addEventListener('click', () => {
      toggleTheme();
      _updateThemeLabel();
    });
  }

  window.addEventListener('themechange', _updateThemeLabel);

  // Sync display name for old-style editor header button
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    const nameEl = document.getElementById('user-menu-name');
    if (nameEl) nameEl.textContent = u.display_name || u.username || 'User';
  } catch (e) {} // storage blocked or corrupted JSON

  // -----------------------------------------------------------------------
  // Logout
  // -----------------------------------------------------------------------
  const _logoutLink = document.getElementById('user-menu-logout');
  if (_logoutLink) {
    _logoutLink.addEventListener('click', (e) => {
      e.preventDefault();
      // Clear client-side auth immediately so in-flight requests during the
      // server round-trip don't include a Bearer token.
      const uid = _localUserId();
      const userPrefix = uid ? ('pcbweave.u' + uid + '.') : null;
      const storages = [localStorage, sessionStorage];
      for (const storage of storages) {
        const keysToRemove = [];
        for (let i = 0; i < storage.length; i++) {
          const key = storage.key(i);
          if (!key) continue;
          if (key.startsWith('pcbweave-') || key.startsWith('pcbweave.u_anon.')
              || (userPrefix && key.startsWith(userPrefix))) {
            keysToRemove.push(key);
          }
        }
        for (const key of keysToRemove) storage.removeItem(key);
      }
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const ctrl = new AbortController();
      const timeout = setTimeout(() => ctrl.abort(), 2000);
      fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin', signal: ctrl.signal })
        .catch(() => {})
        .finally(() => { clearTimeout(timeout); location.href = '/login'; });
    });
  }

  // -----------------------------------------------------------------------
  // Bug report modal (lazy-loaded)
  // -----------------------------------------------------------------------
  const _reportBugLink = document.getElementById('user-menu-report-bug');
  if (_reportBugLink) {
    _reportBugLink.addEventListener('click', (e) => {
      e.preventDefault();
      const dd = document.getElementById('user-menu-dropdown');
      if (dd) dd.style.display = 'none';
      function _callModal() {
        if (typeof window.openBugReportModal === 'function') {
          window.openBugReportModal({ currentUrl: location.href });
        }
      }
      if (typeof window.openBugReportModal === 'function') {
        _callModal();
      } else {
        const scriptSrc = (function() {
          if (/header\.js(\?.*)?$/.test(_headerScriptSrc)) {
            return _headerScriptSrc.replace(/header\.js(\?.*)?$/, 'bug-report-modal.js');
          }
          return '/editor/bug-report-modal.js';
        })();
        const s = document.createElement('script');
        s.type = 'module';
        s.src = scriptSrc;
        s.onload = _callModal;
        document.head.appendChild(s);
      }
    });
  }

  // A-picker is BOM-only; only power-flag defaults are mirrored for the P-picker.
  const _arrayPreferenceSync = [
    { source: 'default_power_flags', key: 'defaultPowerFlags' },
  ];

  function _syncMenuUser(data) {
    const menuBtn = document.getElementById('user-menu-btn');
    if (menuBtn && menuBtn.classList.contains('user-avatar-btn')) {
      if (data.avatar_url) {
        menuBtn.textContent = '';
        let img = menuBtn.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.alt = 'Avatar';
          img.style.cssText = 'width:100%;height:100%;border-radius:50%;object-fit:cover;';
          menuBtn.appendChild(img);
        }
        img.src = data.avatar_url;
      } else {
        menuBtn.innerHTML = '';
        menuBtn.textContent = _getInitials(data.display_name, data.username);
      }
    }

    const nameEl = document.getElementById('user-menu-name');
    if (nameEl) nameEl.textContent = data.display_name || data.username || 'User';

    const profileLink = document.getElementById('user-menu-profile');
    if (profileLink && data.username) {
      profileLink.setAttribute('href', '/' + data.username);
    }
  }

  function _persistStoredUser(data) {
    try {
      const stored = JSON.parse(localStorage.getItem('user') || '{}');
      stored.avatar_url = data.avatar_url || null;
      stored.display_name = data.display_name || null;
      stored.username = data.username || null;
      localStorage.setItem('user', JSON.stringify(stored));
    } catch (e) {} // storage blocked in private/incognito mode
  }

  function _injectAdminLink(data) {
    if (!data.is_admin) return;
    const dd = document.getElementById('user-menu-dropdown');
    if (!dd || document.getElementById('user-menu-admin')) return;
    const adminLink = _makeLink({
      href: '/admin',
      label: 'Admin',
      id: 'user-menu-admin',
      testid: 'user-menu-admin',
      className: 'user-menu-admin',
    });
    const firstLink = dd.querySelector('a');
    if (firstLink) {
      dd.insertBefore(adminLink, firstLink);
    } else {
      dd.appendChild(adminLink);
    }
  }

  function _syncPreferences(prefs) {
    if (!prefs || typeof prefs !== 'object') return;

    if (typeof prefs.units === 'string') {
      const units = prefs.units === 'mil' ? 'mil' : 'mm';
      try {
        localStorage.setItem(_userPrefKey('unitPrefs.units'), units);
      } catch (e) {} // storage blocked in private/incognito mode
      if (window.UnitPrefs && typeof window.UnitPrefs.set === 'function') {
        window.UnitPrefs.set(units);
      }
    }

    if (prefs.hotkeys && typeof prefs.hotkeys === 'object') {
      const hotkeys = prefs.hotkeys;
      try {
        if (Object.keys(hotkeys).length === 0) {
          localStorage.removeItem(_userPrefKey('hotkeys.overrides'));
        } else {
          localStorage.setItem(_userPrefKey('hotkeys.overrides'), JSON.stringify(hotkeys));
        }
      } catch (e) {} // storage blocked in private/incognito mode
      if (window.__pcbweaveKeyboard
          && typeof window.__pcbweaveKeyboard.applyHotkeyOverrides === 'function') {
        window.__pcbweaveKeyboard.applyHotkeyOverrides(hotkeys);
      }
    }

    for (const pref of _arrayPreferenceSync) {
      if (Array.isArray(prefs[pref.source])) {
        try {
          localStorage.setItem(_userPrefKey(pref.key), JSON.stringify(prefs[pref.source]));
        } catch (e) {} // storage blocked in private/incognito mode
      }
    }
  }

  // -----------------------------------------------------------------------
  // /api/auth/me — update avatar, sync preferences
  // -----------------------------------------------------------------------
  const _token = localStorage.getItem('token');
  let _authRefreshPromise = null;

  function _hideVerificationBanner() {
    const banner = document.getElementById('verify-banner');
    if (banner) banner.remove();
  }

  function _syncAuthUser(data) {
    if (!data) return;
    window.currentUser = data;
    if (data.email_verified) {
      _hideVerificationBanner();
    } else {
      _showVerificationBanner();
    }
    _syncMenuUser(data);
    _persistStoredUser(data);
    _injectAdminLink(data);
    _syncPreferences(data.preferences);
  }

  function _refreshAuthState(opts = {}) {
    if (!_token) return Promise.resolve(null);
    if (_authRefreshPromise) return _authRefreshPromise;
    _authRefreshPromise = fetch('/api/auth/me', { headers: { 'Authorization': 'Bearer ' + _token } })
      .then(r => {
        if (r.status === 401) {
          if (opts.redirect401) location.href = '/login';
          return null;
        }
        if (r.status === 403) {
          _showVerificationBanner();
          return null;
        }
        return r.ok ? r.json() : null;
      })
      .then(data => {
        if (data) _syncAuthUser(data);
        return data;
      })
      .catch((err) => {
        console.debug('[silent:auth/me]', err instanceof Error ? err.message : String(err));
        return null;
      })
      .finally(() => {
        _authRefreshPromise = null;
      });
    return _authRefreshPromise;
  }

  function _refreshVerificationIfVisible() {
    if (!document.getElementById('verify-banner')) return;
    _refreshAuthState();
  }

  if (_token) {
    _refreshAuthState({ redirect401: true });
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener('focus', _refreshVerificationIfVisible);
      window.addEventListener('pageshow', _refreshVerificationIfVisible);
    }
  }

  function _makeBanner({ id, role, className, children }) {
    const banner = document.createElement('div');
    banner.id = id;
    if (role) banner.setAttribute('role', role);
    if (className) banner.className = className;
    banner.append(...children);
    return banner;
  }

  function _replaceBannerMessage(banner, kind, text) {
    const msg = document.createElement('span');
    msg.className = 'banner-message banner-message-' + kind;
    msg.textContent = text;
    banner.replaceChildren(msg);
  }

  // -----------------------------------------------------------------------
  // Email verification banner
  // -----------------------------------------------------------------------
  function _showVerificationBanner() {
    if (document.getElementById('verify-banner')) return;
    const resendLink = document.createElement('a');
    resendLink.href = '#';
    resendLink.id = 'resend-verify-link';
    resendLink.className = 'verify-banner-link';
    resendLink.textContent = 'Resend verification email';
    const banner = _makeBanner({
      id: 'verify-banner',
      className: 'verify-banner',
      children: [
        'Please verify your email address to access PCBWeave. Check your inbox for the verification link. ',
        resendLink,
      ],
    });
    document.body.prepend(banner);
    resendLink.addEventListener('click', (e) => {
      e.preventDefault();
      fetch('/api/auth/resend-verification', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
      }).then(r => {
        if (r.ok) {
          _replaceBannerMessage(banner, 'success', '✓ Verification email sent! Check your inbox.');
          _refreshAuthState();
        } else {
          _replaceBannerMessage(banner, 'error', 'Failed to send verification email. Please try again later.');
        }
      });
    });
  }

  // -----------------------------------------------------------------------
  // Pre-launch banner — surface intent to make these surfaces public.
  //
  // Default: hidden on every page that loads header.js. To show it, the
  // backend or page must explicitly emit:
  //   <meta name="pcbw-prelaunch" content="1">
  // -----------------------------------------------------------------------
  function _maybeShowPrelaunchBanner() {
    if (document.getElementById('prelaunch-banner')) return;
    const meta = document.querySelector('meta[name="pcbw-prelaunch"]');
    if (!meta || meta.getAttribute('content') !== '1') return;
    const strong = document.createElement('strong');
    strong.textContent = 'Pre-launch.';
    const em = document.createElement('em');
    em.textContent = 'publicly accessible';
    const banner = _makeBanner({
      id: 'prelaunch-banner',
      role: 'note',
      className: 'prelaunch-banner',
      children: [
        strong,
        ' Profiles and projects will become ',
        em,
        ' at launch — assume anything posted to a public project or library will be visible to anyone.',
      ],
    });
    document.body.prepend(banner);
  }
  _maybeShowPrelaunchBanner();

  // -----------------------------------------------------------------------
  // Toast notifications — owned by ui/toast.js (single implementation).
  // Classic header script loads the ESM module via dynamic import. Until it
  // resolves, queue calls so early callers (e.g. boot errors) are not lost.
  // -----------------------------------------------------------------------
  (function _loadSharedToast() {
    const queue = [];
    const pending = function(msg, type, duration) {
      queue.push([msg, type, duration]);
    };
    // Prefer an already-installed owner (page module imported toast.js first).
    if (typeof window.showToast !== 'function') {
      window.showToast = pending;
    }
    const base = (_headerScriptSrc || '/editor/header.js').replace(/header\.js(\?.*)?$/, '');
    const toastUrl = base + 'ui/toast.js';
    import(toastUrl).then(function(m) {
      if (m && typeof m.showToast === 'function') {
        window.showToast = m.showToast;
        if (typeof m.ensureToastContainer === 'function') m.ensureToastContainer();
      }
      const real = window.showToast;
      if (typeof real === 'function' && real !== pending) {
        for (let i = 0; i < queue.length; i++) real.apply(null, queue[i]);
      }
    }).catch(function(err) {
      console.error('[header] failed to load ui/toast.js', err);
      var reason = (err && err.message) ? err.message : String(err);
      window.showToast = function(msg) {
        var banner = document.getElementById('toast-load-failure');
        if (!banner && document.body) {
          banner = document.createElement('div');
          banner.id = 'toast-load-failure';
          banner.setAttribute('role', 'alert');
          banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:100000;background:var(--color-danger-bg,#7f1d1d);color:var(--color-danger-text,#fff);padding:8px 12px;font:13px/1.4 sans-serif;';
          document.body.appendChild(banner);
        }
        if (!banner) return;
        var line = document.createElement('div');
        line.textContent = String(msg);
        banner.appendChild(line);
      };
      window.showToast('Toast UI failed to load: ' + reason);
      for (var i = 0; i < queue.length; i++) window.showToast(queue[i][0]);
    });
  })();

  // -----------------------------------------------------------------------
  // In-app dialogs — owned by ui/confirm-dialog.js (single implementation).
  // Classic page scripts call window.appDialogs.confirm / notice / prompt;
  // each returns the module's promise. appDialogs.modal registers a page's
  // own modal with the shared modal stack. A load failure is shown and rethrown.
  // -----------------------------------------------------------------------
  (function _installAppDialogs() {
    const base = (_headerScriptSrc || '/editor/header.js').replace(/header\.js(\?.*)?$/, '');
    let loading = null;
    function load() {
      if (!loading) {
        loading = import(base + 'ui/confirm-dialog.js').catch(function(err) {
          loading = null;
          console.error('[header] failed to load ui/confirm-dialog.js', err);
          window.showToast('Dialog failed to load: ' + ((err && err.message) ? err.message : String(err)), 'error');
          throw err;
        });
      }
      return loading;
    }
    window.appDialogs = {
      confirm: function(opts) { return load().then(function(m) { return m.confirmDialog(opts); }); },
      notice: function(opts) { return load().then(function(m) { return m.noticeDialog(opts); }); },
      prompt: function(opts) { return load().then(function(m) { return m.promptDialog(opts); }); },
      // A classic page's own modal joins the shared modal stack
      // (ui/modal-dismiss.js): Escape, focus in, Tab trap, focus return.
      // Returns the handle at once; unregister() before the module has
      // loaded cancels the registration.
      modal: function(onDismiss, root, opts) {
        let handle = null;
        let closed = false;
        load().then(function(m) {
          if (!closed) handle = m.registerModalDismiss(onDismiss, root, opts);
        });
        return {
          unregister: function() {
            closed = true;
            if (handle) handle.unregister();
            handle = null;
          },
        };
      },
    };
  })();
})();
